"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return _tabPanel["default"];
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _tabs["default"];
  }
});
var _tabPanel = _interopRequireDefault(require("./tab-panel"));
var _tabs = _interopRequireDefault(require("./tabs"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}